export const OmyConst = {
    SCALE_SHOW_ALL: 1,
    SCALE_EXACT_FIT: 2,

    OMY_SPRITE: "sprite",
    OMY_CONTAINER: "container",
    OMY_TEXT_FONT: "textFont",
    OMY_MULTI_STYLE_TEXT_FONT: "textMultiStyleFont",
    OMY_MULTI_STYLE_TEXT_NUMBER_FONT: "textMultiStyleNumberFont",
    OMY_TEXT_FONT_INPUT: "textFontInput",
    OMY_TEXT_NUMBER_FONT: "textNumberFont",
    OMY_TEXT_BITMAP: "textBitmap",
    OMY_TEXT_NUMBER_BITMAP: "textNumberBitmap",
    OMY_BUTTON: "button",
    OMY_BUTTON_TWEEN: "buttonMobile",
    OMY_CHECK_BOX_TWEEN: "checkBoxTween",
    OMY_CHECK_BOX: "checkBox",
    OMY_ACTOR: "actor",
    OMY_ACTOR_SPINE: "actorSpine",
    OMY_GRAPHIC: "graphic",
    OMY_PARTICLE: "particle",
    OMY_PARTICLE_CONTAINER: "particleContainer",
    OMY_RECT: "rect",
    OMY_REVOLT_EMMITER: "revoltEmmiter",
    OMY_REVOLT_SEQUENCE: "revoltSequence",
    OMY_SLIDER: "slider",
    OMY_NEUTRINO_PARTICLES: "neutrinoParticles",

    Graphics: PIXI.Graphics,

    Rectangle: PIXI.Rectangle,
    TextStyle: PIXI.TextStyle,
    Emit: PIXI.utils.EventEmitter,
};

export const OMY_SETTING = {
    WEBP_SUPPORT: false,
    OGG_SUPPORT: true,
    CACHE_SPINE_ON_START: false,
    TEXT_NUMBER_SHOW_CENT: true,
    /**
     * Hide/show messages about button state and blocking screen from console
     * @typedef {boolean} default=true
     */
    VERBOSE_BUTTONS_STATE: true,
    SHOW_FPS: false,
    CHECK_IOS_FULLSCREEN: false,
    NO_CACHE_ASSETS_ON_LOAD: false,
    ALLOW_DESK_SIZE: false,
    RENDER_FPS: 60,
    NUMBER_FORMAT: "en-US",
    SPINE_ACTOR_PLAY_LOG: false,
    ONLY_PORT_MODE: false,
};
